<template lang="pug">
div
  stock-take-desktop(:id="id" :savePage="savePage" :saveTab="saveTab" :saveSearch="saveSearch" :saveFilters="saveFilters" list-page="ClinicInventoryStockTake" summary-page="ClinicInventoryStockTakeSummary")

</template>

<script>
import StockTakeDesktop from '@/components/clinic/inventory/stocktake/StockTakeDesktop.vue'

export default {
  name: 'StockTake',
  components: { StockTakeDesktop },
  props: ['id', 'savePage', 'saveTab', 'saveSearch', 'saveFilters'],
  data () {
    return {}
  },
  computed: {},
  watch: {},
  mounted () {},
  methods: {}
}
</script>

<style lang="scss" scoped>
</style>